module.exports = "\r\n<div id=\"sidebar-wrapper\" [class.active]=\"isParaActive\">\r\n  <ul class=\"sidebar-nav\" >\r\n    <button class=\"btn btn-default btn-lg pull-right toggle\" (click)=\"toggleClass()\"></button>\r\n    <li class=\"sidebar-brand\">\r\n      <a href=\"#\">Project name</a>\r\n    </li>\r\n    <li>\r\n      <a href=\"#\">Home</a>\r\n    </li>\r\n    <li>\r\n      <a href=\"#about\">About</a>\r\n    </li>\r\n    <li>\r\n      <a href=\"#contact\">Contact</a>\r\n    </li>\r\n  </ul>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/filters/filters.component.html
// module id = ./src/app/common/filters/filters.component.html
// module chunks = main